import React from 'react';
import { Monitor } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
interface FooterProps {
  onPrivacyClick: () => void;
}
export function Footer({
  onPrivacyClick
}: FooterProps) {
  const {
    t
  } = useLanguage();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  // Map footer company items to actions
  const companyLinks: {
    label: string;
    action: () => void;
  }[] = [{
    label: t.footer.company.items[0],
    action: () => scrollToSection('about')
  }, {
    label: t.footer.company.items[1],
    action: () => scrollToSection('portfolio')
  }, {
    label: t.footer.company.items[2],
    action: () => scrollToSection('contact')
  }, {
    label: t.footer.company.items[3],
    action: () => scrollToSection('contact')
  }, {
    label: t.footer.company.items[4],
    action: onPrivacyClick
  }];
  return <footer className="bg-slate-950 border-t border-white/5 pt-16 pb-8" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-84">
          <div className="col-span-1 md:col-span-2" data-id="element-85">
            <div className="flex items-center gap-2 mb-6 cursor-pointer group" onClick={() => scrollToSection('hero')} data-id="element-86">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-cyan-400 to-blue-600 flex items-center justify-center text-slate-950 group-hover:scale-105 transition-transform" data-id="element-87">
                <Monitor size={16} strokeWidth={2.5} data-id="element-88" />
              </div>
              <span className="text-lg font-bold text-white tracking-tight" data-id="element-89">
                Quick<span className="text-cyan-400" data-id="element-90">Designs</span>
              </span>
            </div>
            <p className="text-slate-400 max-w-sm" data-id="element-91">{t.footer.description}</p>
          </div>

          <div data-id="element-92">
            <h4 className="text-white font-bold mb-6" data-id="element-93">
              {t.footer.services.title}
            </h4>
            <ul className="space-y-4" data-id="element-94">
              {t.footer.services.items.map(item => <li key={item} data-id="element-95">
                  <button onClick={() => scrollToSection('contact')} className="text-slate-400 hover:text-cyan-400 transition-colors text-left" data-id="element-96">
                    {item}
                  </button>
                </li>)}
            </ul>
          </div>

          <div data-id="element-97">
            <h4 className="text-white font-bold mb-6" data-id="element-98">
              {t.footer.company.title}
            </h4>
            <ul className="space-y-4" data-id="element-99">
              {companyLinks.map((link, index) => <li key={index} data-id="element-100">
                  <button onClick={link.action} className="text-slate-400 hover:text-cyan-400 transition-colors text-left" data-id="element-101">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-102">
          <p className="text-slate-500 text-sm" data-id="element-103">{t.footer.copyright}</p>
          <p className="text-slate-500 text-sm flex items-center gap-1" data-id="element-104">
            {t.footer.madeWith} <span className="text-red-500" data-id="element-105">♥</span>{' '}
            {t.footer.location}
          </p>
        </div>
      </div>
    </footer>;
}